import React from 'react';
import placeholderImage from '../images/hands.jpg';
/* Pexels JPG icons no longer used — replaced with inline SVGs below.
import missionIcon from '../images/pexels.jpg';
import visionIcon from '../images/pexels.jpg';
*/

const MissionIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="12" cy="12" r="1.5" fill="currentColor" />
    </svg>
);

const VisionIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6" aria-hidden="true">
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

const WhyTexcellence = () => {
    return (
        <div className="bg-white py-16 px-6 lg:px-16" id="why-texcellence">
            <div className="max-w-[1600px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-14">
                {/* Image Section */}
                <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
                    <div className="relative">
                        <div className="absolute -inset-3 bg-[#5b2a2a]/5 rounded-2xl -z-10" aria-hidden="true"></div>
                        <img
                            src={placeholderImage}
                            alt="Why Choose Texcellence"
                            className="w-full h-auto object-cover rounded-2xl shadow-[0_20px_60px_rgba(91,42,42,0.12)]"
                        />
                    </div>
                </div>

                {/* Text Section */}
                <div className="w-full lg:w-1/2">
                    <div className="text-sm font-bold tracking-[0.22em] uppercase text-[#5b2a2a] mb-5 flex items-center gap-3">
                        <span className="w-10 h-[2px] bg-[#5b2a2a]"></span>
                        Why Texcellence
                    </div>
                    <h3 className="text-3xl md:text-4xl lg:text-[2.6rem] font-bold text-[#1f2937] tracking-tight leading-[1.15] mb-5">
                        Why choose <span className="text-[#5b2a2a]">Texcellence?</span>
                    </h3>
                    <p className="text-base md:text-lg text-[#4b5563] leading-relaxed mb-8">
                        Texcellence Specialties Private Limited is dedicated to providing innovative chemical solutions that add value at every stage of the textile production process. We combine state-of-the-art facilities, cutting-edge research, and a team of skilled professionals to ensure that our products meet the highest standards of quality and sustainability.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                        <div className="group bg-white border border-[#f0e6e6] rounded-2xl p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_14px_32px_rgba(91,42,42,0.10)] hover:border-[#5b2a2a]/30">
                            <div className="w-11 h-11 rounded-xl bg-[#5b2a2a]/5 text-[#5b2a2a] flex items-center justify-center mb-3 group-hover:bg-[#5b2a2a] group-hover:text-white transition-colors duration-300">
                                <MissionIcon />
                            </div>
                            <h4 className="text-base font-bold text-[#5b2a2a] mb-1.5">Our Mission</h4>
                            <p className="text-sm text-[#4b5563] leading-relaxed">
                                To be a global leader in textile chemicals, committed to sustainability and innovation.
                            </p>
                        </div>
                        <div className="group bg-white border border-[#f0e6e6] rounded-2xl p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_14px_32px_rgba(91,42,42,0.10)] hover:border-[#5b2a2a]/30">
                            <div className="w-11 h-11 rounded-xl bg-[#5b2a2a]/5 text-[#5b2a2a] flex items-center justify-center mb-3 group-hover:bg-[#5b2a2a] group-hover:text-white transition-colors duration-300">
                                <VisionIcon />
                            </div>
                            <h4 className="text-base font-bold text-[#5b2a2a] mb-1.5">Our Vision</h4>
                            <p className="text-sm text-[#4b5563] leading-relaxed">
                                To spread the colors of excellence across the globe, enhancing the beauty and quality of textiles.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhyTexcellence;
